import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isRequestingCardsFirstTime = createSelector(
    creditCardsState,
    creditCards => Boolean(creditCards.data?.length) === false && creditCards.download.isDownloading && creditCards.download.downloadedDate === null
);
